<template>
    <strong>{{currentStep}} of {{totalSteps}} Steps</strong>
    <div
      class="progress-bar"
      :style="{ '--progress': progress + '%' }"
    />
    
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  totalSteps: Number,
  currentStep: Number,
});

const progress = computed(() => {
  return Math.round(((props.currentStep) / props.totalSteps) * 100);
});

</script>

<style scoped>
.progress-bar::after {
  background-color: #FF5A50;
}

div {
  margin-top: 10px;
}

</style>
